export default __webpack_public_path__ + "static/realWorldImg2-fcbc446e7e78989f0da3b7ca0c2353a9.png";